/**
 * @file
 * Resource centre functions.
 */
const { addPill } = require("../search-helper");

const handleKeywordsField = (form) => {
  const keywordsField = form.querySelector('input[name="keywords"]');
  const keywordsFieldWrapper = keywordsField.closest(".form-item-keywords");
  const keywordsForm = document.querySelector(".keywords--form");
  // Clone the keywords field and add it to the .keywords--form.
  const keywordsFieldClone = keywordsFieldWrapper.cloneNode(true);
  keywordsForm.appendChild(keywordsFieldClone);
  const keywordsFieldCloneInput = keywordsFieldClone.querySelector("input");
  keywordsFieldCloneInput.classList.remove("d-none");
  keywordsFieldCloneInput.classList.add("learning-center-keyword-field");
  // Add event to populate the original keywords field.
  keywordsFieldCloneInput.addEventListener("change", (event) => {
    keywordsField.value = event.target.value;
  });
  // Get the submit button from form.
  const submitButton = form.querySelector("input[type='submit']");
  // Add event handle enter keypress.
  keywordsFieldCloneInput.addEventListener("keypress", (event) => {
    // If enter key is pressed, add the value to the keywords field.
    if (event.key === "Enter") {
      keywordsField.value = event.target.value;
      event.preventDefault();
      if (submitButton) {
        submitButton.click();
      }
    }
  });

  // On focus out, add the value to the keywords field.
  keywordsFieldCloneInput.addEventListener("blur", (event) => {
    keywordsField.value = event.target.value;
  });

  // If keywords field has value add pill.
  if (keywordsField.value) {
    const kForm = keywordsField.closest("form");
    const label = kForm.querySelector(
      `[for="${keywordsField.id}"]`
    ).textContent;
    const pill = addPill(
      `${label}: ${keywordsField.value}`,
      keywordsField.name,
      form.id
    );
    if (pill) {
      pill.addEventListener("click", (event) => {
        event.preventDefault();
        keywordsField.value = "";
        if (submitButton) {
          submitButton.click();
        }
      });
    }
  }

  const button = document.createElement("button");
  button.type = "submit";
  button.classList.add(
    "btn",
    "btn-link",
    "link-dark",
    "d-flex",
    "text-decoration-none",
    "shadow-none",
    "p-0",
    "btn-search",
    "position-absolute",
    "top-50",
    "top-n50",
    "end-0",
    "me-3"
  );
  keywordsForm.querySelector(".form-item-keywords").appendChild(button);

  button.addEventListener("click", (event) => {
    keywordsField.value = keywordsFieldCloneInput.value;
    event.preventDefault();
    if (submitButton) {
      submitButton.click();
    }
  });
};

const handleTitlePosition = (form) => {
  const title = form.querySelector("h2.resources-title");

  if (!title) {
    return;
  }

  const resourceResults = form.querySelector(".resource-results");

  // Move the title to the top of the results.
  resourceResults.prepend(title);
};

const handleMobileCollapsibleFilters = (context) => {
  const forms = once("mobile-collapsible-filters", ".view-filters", context);

  forms.forEach((form) => {
    const isMobile = window.matchMedia(
      "only screen and (max-width: 991px)"
    ).matches;
    const filters = form.querySelector("#collapse-views-filters");

    if (isMobile) {
      filters.classList.add("collapse");
      return;
    }
    filters.classList.remove("collapse", "show");
  });
};

function calcCardSizes(card, useFooter = false) {
  // Set the card height to 100%.
  card.style.height = "100%";

  // Check if the card footer description isn't overflowing and show the icon.
  let cardDescription = card.querySelector(".card-footer p");
  if (useFooter === true) {
    cardDescription = card.querySelector(".description p");
  }
  const cardDescriptionScrollHeight = cardDescription.scrollHeight;
  const cardDescriptionInnerHeight = cardDescription.clientHeight;
  let expandingIcon = card.querySelector(".card-footer .collapsed");
  if (useFooter === true) {
    expandingIcon = card.querySelector(".description .collapsed");
  }
  expandingIcon.classList.remove("d-none");

  if (cardDescriptionScrollHeight <= cardDescriptionInnerHeight) {
    expandingIcon.classList.add("d-none");
  }

  // Check if desktop view.
  if (window.matchMedia("only screen and (min-width: 992px)").matches) {
    // Get the card height.
    const cardHeight = card.offsetHeight;
    card.style.height = `${cardHeight}px`;
    card.setAttribute("data-card-height", cardHeight);
    // Get the card body height.
    const cardBody = card.querySelector(".card-body");
    const cardBodyHeight = cardBody.offsetHeight;
    cardBody.style.minHeight = `${cardBodyHeight}px`;
  }
}

const resetCard = (card) => {
  card.style.height = null;
  card.removeAttribute("data-card-height");
  card.querySelector(".card-body").style.minHeight = null;
};

function resetCards(cards, useFooter = false) {
  setTimeout(() => {
    cards.forEach((card) => {
      resetCard(card);
    });

    cards.forEach((card) => {
      calcCardSizes(card, useFooter);
    });
  }, 100);
}
const handleCards = (context, useFooter = false) => {
  const cards = once("handle-cards", ".card", context);

  cards.forEach((card) => {
    calcCardSizes(card, useFooter);
  });

  // This event fires immediately when the show instance method is called.
  document.addEventListener("show.bs.collapse", (event) => {
    // Remove the card height style property.
    const card = event.target.closest(".card");
    if (!card) {
      return;
    }
    card.style.height = null;
  });

  // This event is fired when a collapse element has been hidden from the user
  // (will wait for CSS transitions to complete).
  document.addEventListener("hidden.bs.collapse", (event) => {
    // Reset the card height style property.
    const card = event.target.closest(".card");
    if (!card) {
      return;
    }
    card.style.height = `${card.getAttribute("data-card-height")}px`;
  });

  resetCards(cards, useFooter);
};

const handleResourceReset = (form) => {
  // Double click in the reset button to clear the form.
  const resetButton = form.querySelector("input[name='reset']");

  // On click, click again.
  resetButton.addEventListener("click", (event) => {
    event.preventDefault();

    // Remove all the parameters from the URL.
    window.history.replaceState({}, document.title, window.location.pathname);

    // Click the button again.
    resetButton.click();
  });
};

module.exports = {
  handleKeywordsField,
  handleTitlePosition,
  handleMobileCollapsibleFilters,
  handleCards,
  handleResourceReset,
  resetCards,
  resetCard,
  calcCardSizes,
};
